import LegalPage from "@/pages/LegalPage";

const SECTIONS = [
  {
    title: "1. Who we are",
    body: [
      "Book Away is the last-minute marketplace for beauty and grooming. This Privacy Policy explains how we collect, use, and protect personal information when you use our website, app, or partner dashboard.",
    ],
  },
  {
    title: "2. Information we collect",
    body: [
      "Account & business data — the salon name, owner name, and email you provide when you join the network, along with your role and any preferences you set.",
      "Booking data — the appointment slots, categories, and messages you exchange with clients when you use the platform.",
      "Technical data — device and browser type, IP address, and interaction data captured through standard cookies for security, analytics, and product improvement.",
    ],
  },
  {
    title: "3. How we use your information",
    body: [
      "To provide the Service, including matching last-minute slots with nearby clients and sending booking or Foundation-membership alerts.",
      "To send transactional emails (welcome, booking, receipts) from hello@bookaway.com.au.",
      "To improve the Service, prevent fraud and abuse, and comply with our legal obligations.",
    ],
  },
  {
    title: "4. Cookies",
    body: [
      "We use only strictly necessary cookies (session, authentication, and CSRF). We do not sell your data or share it with third-party ad networks.",
    ],
  },
  {
    title: "5. Sharing",
    body: [
      "We do not sell personal data. We may share limited information with vetted service providers (hosting, database, and — once wired — our transactional email provider) strictly to operate the Service, and with authorities when legally required.",
    ],
  },
  {
    title: "6. Your rights",
    body: [
      "Depending on where you live, you may have rights to access, correct, delete, or export your personal data, and to withdraw consent to processing. To exercise any of these rights, contact us using the details below.",
    ],
  },
  {
    title: "7. Data retention & security",
    body: [
      "We retain personal data for as long as your account is active and as needed to meet legal or record-keeping obligations. We use encrypted connections, hashed passwords (bcrypt), and access controls to protect your data.",
    ],
  },
  {
    title: "8. International transfers",
    body: [
      "Our platform is hosted in secure cloud regions. If your data is transferred outside your country, we use appropriate safeguards recognised by applicable law.",
    ],
  },
  {
    title: "9. Changes to this policy",
    body: [
      "We may update this Privacy Policy from time to time. Material changes will be communicated by email or in-app notice.",
    ],
  },
];

export default function Privacy() {
  return <LegalPage kind="privacy" sections={SECTIONS} />;
}
